import { createAction, props } from '@ngrx/store';
import { DropdownData } from '@zayan-erp/shared';

// SalesOffice
export const loadSalesOffices = createAction('[SalesOffice] Load SalesOffices');
export const loadSalesOfficesSuccess = createAction(
  '[SalesOffice] Load SalesOffices Success',
  props<{ salesOffices: DropdownData[] }>()
);

// Sales Offices Public
export const loadSalesOfficesPublic = createAction('[SalesOffice] Load SalesOffices Public');
export const loadSalesOfficesPublicSuccess = createAction(
  '[SalesOffice] Load SalesOffices Public Success',
  props<{ salesOffices: DropdownData[] }>()
);

// Agencies
export const loadAgencies = createAction('[Agencies] Load Agencies');
export const loadAgenciesSuccess = createAction(
  '[Agencies] Load Agencies Success',
  props<{ agencies: DropdownData[] }>()
);

// Sales Agents
export const loadSalesAgents = createAction('[Sales] Load Sales Agents');
export const loadSalesAgentsSuccess = createAction(
  '[Sales] Load Sales Agents Success',
  props<{ salesAgents: DropdownData[] }>()
);

// Agency Realtors (R/E Agents)
export const loadAgencyRealtors = createAction('[Sales] Load Agency Realtors');
export const loadAgencyRealtorsSuccess = createAction(
  '[Sales] Load Agency Realtors Success',
  props<{ agencyRealtors: DropdownData[] }>()
);

export const loadSalesProjectLots = createAction('[Sales] Load Project Lots', props<{ projectId: string }>());
export const loadSalesProjectLotsSuccess = createAction(
  '[Sales] Load Project Lots Success',
  props<{ projectId: string; lots: { id: string; lotNo: string }[] }>()
);
export const loadSalesProjectLotsFailure = createAction(
  '[Sales] Load Project Lots Failure',
  props<{ projectId: string }>()
);
